import { render, staticRenderFns } from "./payment-details.vue?vue&type=template&id=0b49f61c&scoped=true"
import script from "./payment-details.vue?vue&type=script&lang=ts"
export * from "./payment-details.vue?vue&type=script&lang=ts"
import style0 from "./payment-details.vue?vue&type=style&index=0&id=0b49f61c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_169bdbd7e32539014db8c98595250064/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b49f61c",
  null
  
)

export default component.exports